import { TabNavigationBar } from './_tab_navigation_bar.component';
import { TabNavigationContent } from './_tab_navigation_content.component';
import { Root } from './_tab_navigation_root.component';

export type { TabNavigationBarProps } from './_tab_navigation_bar.component';
export type { TabNavigationContentProps } from './_tab_navigation_content.component';
export type { TabNavigationRootProps } from './_tab_navigation_root.component';

/**
 * The <TabNavigation /> component lets users navigate between related sections of content, displaying one section at a time.
 */
export const TabNavigation = {
	Root: Root,
	Content: TabNavigationContent,
	Bar: TabNavigationBar,
} as const;
